export default function initCustomPasswordFields() : void {
    document.querySelectorAll<HTMLElement>('.custom-password-field').forEach($container => {
        const $input = $container.querySelector<HTMLInputElement>('input');
        const $toggleBtn = $container.querySelector<HTMLButtonElement>('button');
        const $showIcon = $toggleBtn?.querySelector<HTMLSpanElement>('.ico-show');
        const $hideIcon = $toggleBtn?.querySelector<HTMLSpanElement>('.ico-hide');

        if ($input && $toggleBtn && $showIcon && $hideIcon) {
            $toggleBtn.addEventListener('click', () => {
                const passwordIsHidden = $showIcon.classList.contains('hidden');

                $showIcon.classList.toggle('hidden', !passwordIsHidden);
                $hideIcon.classList.toggle('hidden', passwordIsHidden);

                $input.setAttribute('type', !passwordIsHidden ? 'text' : 'password');
                $toggleBtn.setAttribute('aria-pressed', (!passwordIsHidden).toString());
            });
        }
    });
}
